import { t as e } from "../../constants-B7fXbm2f.js";
import { t } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as n, createElementVNode as r, normalizeClass as i, openBlock as a } from "vue";
//#region ../src/icons/tools.vue
var o = {
	name: "DtIconTools",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (t) => Object.keys(e).includes(t)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return e[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded");
	}
}, s = [
	"aria-label",
	"data-qa",
	"aria-hidden"
];
function c(e, t, o, c, l, u) {
	return a(), n("svg", {
		"aria-label": o.ariaLabel,
		class: i([u.iconSizeClass, "d-icon d-icon--tools"]),
		"data-qa": u.dataQA,
		"aria-hidden": u.ariaHidden,
		role: "img",
		"data-name": "Tools",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [...t[0] || (t[0] = [r("path", {
		fill: "currentColor",
		"fill-rule": "evenodd",
		d: "M8.279 1.514A2.5 2.5 0 0 0 5.72 5.029a.5.5 0 0 1-.102.56L2.164 9.042a.56.56 0 0 0 .792.793L6.411 6.38a.5.5 0 0 1 .56-.102 2.5 2.5 0 0 0 3.515-2.558L9.2 5.007a1 1 0 0 1-1.4 0l-.004-.004-.803-.803a1 1 0 0 1 0-1.4l.003-.004L8.28 1.514ZM7.37.554A3.5 3.5 0 0 1 9.44.81a.5.5 0 0 1 .148.81L7.706 3.5l.793.794 1.881-1.882a.5.5 0 0 1 .81.148 3.5 3.5 0 0 1-4.304 4.76l-3.223 3.224a1.56 1.56 0 1 1-2.208-2.207L4.68 5.112A3.5 3.5 0 0 1 7.37.555Z",
		"clip-rule": "evenodd"
	}, null, -1)])], 10, s);
}
var l = /* @__PURE__ */ t(o, [["render", c]]);
//#endregion
export { l as default };

//# sourceMappingURL=tools.js.map